import { BrowserRouter, Navigate, Route } from "react-router-dom";
import { NavBar } from "./components/Navbar";
import { Box } from "@mui/material";
import { RoutesWithnotfound } from "./utils";
import { AuthGuard } from "./guards/auth-guard";
import { PrivateRoutes, PublicRoutes } from "./routes";
import { Inicio } from "./pages/Inicio";
import { Error } from "./pages/Error";
import { FooterBar } from "./components/FooterBar";
import { setBaseURL } from "./api/onboardingTarjetas";
import { Private } from "./pages/Private";
import React, { useEffect } from "react";
import { LoadingModalProps } from "./models";
import { LoadingModal } from "./components";
import { useSelector } from "react-redux";
import { AppStore } from "./redux/stores";
import { infoGlobal } from "./api/infoGlobal";
import { PoseeTarjetas } from "./pages/PoseeTarjetas";
import { SinProductos } from "./pages/SinProductos";
import "./components/logger"; 

interface Window {
  __env: {
    apiUrl: string;
    channel?: string;
    enableDebug: boolean;
  };
}

const initialLoadingModalState: LoadingModalProps = {
  openLM: false,
  messageLM: 'Cargando',
};

function App ()
{
  const globalLoadingModal = useSelector((state: AppStore) => state.loading);
  const [loadingModal, setLoadingModal] = React.useState<LoadingModalProps>(initialLoadingModalState);
  
  useEffect(() => {
    setLoadingModal(globalLoadingModal);
  }, [globalLoadingModal]);

  // console.log(infoGlobal.GetUrlBase());
  const apiUrl = infoGlobal.GetUrlBase();
  setBaseURL(apiUrl);
    // if (!window.origin.toLowerCase().includes("localhost") || !window.origin.toLowerCase().includes("dev"))
    // {
    //   setBaseURL(window.origin);
    // }
        
    return (
        <BrowserRouter>
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <NavBar />
            <Box sx={{ marginTop: '0px', minHeight: 'calc(100vh - 15vh)' }}>
              <LoadingModal openLM={loadingModal.openLM} messageLM={loadingModal.messageLM} />
                <RoutesWithnotfound>
                  <Route path='/' element={ <Navigate to="inicio" />} />
                  <Route path={ `/${PublicRoutes.INICIO}` } element={<Inicio/>} />
                  <Route path={ `/${PublicRoutes.ERROR}` } element={<Error/>} />
                  <Route element={<AuthGuard/>}>          
                    <Route path={ `/${PrivateRoutes.PRIVATE}/*` } element={<Private onLoadingModal={setLoadingModal}/>} />
                  </Route>           
                  <Route path={ `/${PublicRoutes.POSEETARJETAS}` } element={<PoseeTarjetas/>} />  
                  <Route path={ `/${PublicRoutes.SINPRODUCTOS}` } element={<SinProductos/>} />  
                </RoutesWithnotfound>              
            </Box>
            <FooterBar />
          </div>
        </BrowserRouter>
    );
}


export default App;
